import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import vuetify from "./plugins/vuetify";
import "@plugins/config";
import "@plugins/global";
import "@plugins/lodash";
import "@plugins/toast";
import "@/plugins/clipboard";
import "@/plugins/vue-uuid";
import mocks from "@/plugins/mocks";
// We'll store the mocks globally for each api, mocking is enabled via env var
window.mocks = mocks;

// TODO: Design out dependency on Laravel CSRF token here
Vue.prototype.$app = { csrfToken: "" };

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
